import { React, Component, Container, _ } from 'utils';
import { ActiveInfoStore } from 'model';
import './activeusers.less';

class ActiveUsers extends Component {

	static getStores() {
		return [ ActiveInfoStore ];
	}

	static calculateState() {
		return {
			active: ActiveInfoStore.getActiveUserCount()
		}
	}

	render() {

		var { active } = this.state;

		if(active == 0) {
			return null;
		} else {
			return <div className="active-users">
				{_('Online')} <span className="counter">{ active }</span>
			</div>
		}
	}

}

export default Container.create(ActiveUsers);


// WEBPACK FOOTER //
// ./src/modules/components/activeusers.js